import React, { useContext } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { icons } from "../../../constants";

const FormInput = ({
  placeholder,
  label,
  value,
  handleValueChange,
  error,
  type,
  onKeyDown,
  disabled,
  autoComplete,
  name,
  required,
}) => {
  const handleChange = (event) => {
    handleValueChange(event.target.value);
  };

  const { t, isLoading } = useContext(TranslationsContext);

  return (
    <div
      className={`flex-direction-column items-center gap-8 width-100 height-100 form-input ${
        disabled ? "disabled" : ""
      }`}
    >
      {label && (
        <div className="flex-direction-row items-center width-100 relative">
          {required && (
            <img
              src={icons.required}
              alt="req"
              width={12}
              height={12}
              style={{ position: "absolute", top: "0px", left: "0" }}
            />
          )}
          <label className="font-12 inria-sans-700">{label}</label>
        </div>
      )}
      <div className="width-100 flex-direction-column items-center">
        <input
          className={`inria-sans-300 font-12 ${error ? "invalid" : ""} `}
          placeholder={placeholder}
          value={value}
          onKeyDown={onKeyDown}
          disabled={disabled}
          onChange={handleChange}
          type={
            type === "datetime-local"
              ? "datetime-local"
              : type === "lat" || type === "lng"
                ? "number"
                : "text"
          }
          autoComplete={autoComplete}
          name={name}
          id={name}
        />

        {error && type === "lat" && (
          <p className="font-12 inria-sans-400 error-message">
            {t("LAT_ERROR")}
          </p>
        )}
        {error && type === "lng" && (
          <p className="font-12 inria-sans-400 error-message">
            {t("LNG_ERROR")}
          </p>
        )}
      </div>
    </div>
  );
};

export default FormInput;
